import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';
import {ConstantsService} from "../../services/constants/constants.service";

@Component({
  selector: 'app-perf-metrics',
  templateUrl: './perf-metrics.component.pug',
  styleUrls: ['./perf-metrics.component.scss'],
  standalone: false
})
export class PerfMetricsComponent implements OnInit, OnChanges {

  @Input() perfMetrics: any[] = [];
  perf_metrics: any[] = [];
  expansionText: any = $localize`Show more`;
  expanded = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  chunk(array, size) {
    const chunked_arr: any = [];
    let index = 0;
    while (index < array.length) {
      chunked_arr.push(array.slice(index, size + index));
      index += size;
    }
    return chunked_arr;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.perf_metrics = [];
    // Ensure perfMetrics is an array before processing
    if (!Array.isArray(this.perfMetrics) || this.perfMetrics.length === 0) {
      return;
    }
    this.perfMetrics.sort(function (a, b) {
      return b['value'] - a['value'];
    });
    let chunked_data = _.chunk(this.perfMetrics, 4);

    for (let chunk of chunked_data) {
      let perf_metric: any[] = [];
      for (let d of chunk) {
        let icon_map = ConstantsService.METRICS_ICON_MAP[d['metric']];
        let icon = '', metric = 'Other';
        if (icon_map !== undefined) {
          metric = icon_map['label'];
          if (d['value'] > 3.9999) {
            icon = icon_map['metric_green_icon']
          } else if (d['value'] > 2.9999) {
            icon = icon_map['metric_amber_icon']
          } else {
            icon = icon_map['metric_red_icon']
          }
        }
        const rawValue = d['value'];
        perf_metric.push({
          'label': metric,
          'icon': icon,
          'value': rawValue ? Math.round((((9 * (rawValue - 1)) / 4) + 1) * 10) / 10 : null,
        });
      }
      this.perf_metrics.push(perf_metric);
    }
  }

  showMore() {
    let transitionBlock =  "pf-blocks-single-block"
    let collapsedBlock = "performance-single-blocks-collapsed"
    let expandedBlock = "performance-single-blocks-expanded"
    let doc = document.getElementById(transitionBlock);
    this.expanded = !this.expanded;
    if (this.expanded && doc) {
      this.expansionText = $localize`Show less`;
      doc.classList.add(expandedBlock);
      doc.classList.remove(collapsedBlock);
    } else {
      this.expansionText = $localize`Show more`;
      doc?.classList.remove(expandedBlock);
      doc?.classList.add(collapsedBlock);
    }
  }

}
